module.exports = __webpack_public_path__ + "img/en-pc-s4.e1b61d2e.png";